// import { YULI_PROPERTY } from "@/constants/enums";

export const YULI_PROPERTY = {
  PROTOTYPE: 1,
  COMMON: 2,
  UNCOMMON: 3,
  SUPERIOR: 4,
  EPIC: 5,
  LEGENDARY: 6,
};

export const YULI_ROLE_TYPE = {
  wind: 1,
  rock: 2,
  ice: 3,
  fire: 4,
  thunder: 5,
};

/** yuli品质*/
export const YULI_QUALITY_TYPE = {
  // GRAY = 'prototype',
  WHITE: "common",
  GREEN: "uncommon",
  BLUE: "superior",
  PURPLE: "epic",
  GOLDEN: "legendary",
};

export const YULI_QUALITY_TYPE_MAP = {
  [YULI_PROPERTY.COMMON]: YULI_QUALITY_TYPE.WHITE,
  [YULI_PROPERTY.UNCOMMON]: YULI_QUALITY_TYPE.GREEN,
  [YULI_PROPERTY.SUPERIOR]: YULI_QUALITY_TYPE.BLUE,
  [YULI_PROPERTY.EPIC]: YULI_QUALITY_TYPE.PURPLE,
  [YULI_PROPERTY.LEGENDARY]: YULI_QUALITY_TYPE.GOLDEN,
};

/**
 * Yuli类型枚举
 */
export const YULI_ROLE_TYPE_MAP = {
  [YULI_ROLE_TYPE.wind]: "wind",
  [YULI_ROLE_TYPE.rock]: "rock",
  [YULI_ROLE_TYPE.ice]: "ice",
  [YULI_ROLE_TYPE.fire]: "fire",
  [YULI_ROLE_TYPE.thunder]: "thunder",
};

export const YULI_ROLE_PROPERTY_TYPE_MAP = {
  [YULI_PROPERTY.PROTOTYPE]: "prototype",
  [YULI_PROPERTY.COMMON]: "common",
  [YULI_PROPERTY.UNCOMMON]: "uncommon",
  [YULI_PROPERTY.SUPERIOR]: "superior",
  [YULI_PROPERTY.EPIC]: "epic",
  [YULI_PROPERTY.LEGENDARY]: "legendary",
};

export const TIME_TYPE = {
  days6: 6,
  days16: 16,
  days30: 30,
  days60: 60,
};

/** yuli品质 服务端对应参数*/
export const YULI_QUALITY_API_VALUE = {
  [YULI_QUALITY_TYPE.WHITE]: 2,
  [YULI_QUALITY_TYPE.GREEN]: 3,
  [YULI_QUALITY_TYPE.BLUE]: 4,
  [YULI_QUALITY_TYPE.PURPLE]: 5,
  [YULI_QUALITY_TYPE.GOLDEN]: 6,
};

export const TIME_TYPE_GROUP = [
  {
    key: TIME_TYPE.days60,
    label: "60 Days",
  },
  {
    key: TIME_TYPE.days30,
    label: "30 Days",
  },
  {
    key: TIME_TYPE.days16,
    label: "16 Days",
  },
  {
    key: TIME_TYPE.days6,
    label: "6 Days",
  },
];

export const REWARD_TYPE = {
  Passcard: "Passcard",
  Art: "ART",
  YuliExp: "Yuli EXP",
};

export const REWARD_GROUP = [
  {
    icon: require("@/assets/images/YuliApp/YuliStaking/icon_passcard.png"),
    name: REWARD_TYPE.Passcard,
    key: 0,
  },
  {
    icon: require("@/assets/images/YuliApp/YuliStaking/icon_art.png"),
    name: REWARD_TYPE.Art,
    key: 0,
  },
  {
    icon: require("@/assets/images/YuliApp/YuliStaking/icon_exp.png"),
    name: REWARD_TYPE.YuliExp,
    key: 0,
  },
];

/** 折扣数组根据名称关键词转对象 - 对应不同道具*/
export const DISCOUNT_PROP_MAP = {
  [YULI_QUALITY_TYPE.WHITE]: {
    text: "I",
    prop_id: "118557359793504257",
    discount: 0.8,
    icon: require("@/assets/images/YuliApp/YuliStaking/prop/white_staking_discount_coupon.png"),
  },
  [YULI_QUALITY_TYPE.GREEN]: {
    text: "II",
    prop_id: "",
    discount: 0.7,
    icon: require("@/assets/images/YuliApp/YuliStaking/prop/green_staking_discount_coupon.png"),
  },
  [YULI_QUALITY_TYPE.BLUE]: {
    text: "III",
    prop_id: "",
    discount: 0.6,
    icon: require("@/assets/images/YuliApp/YuliStaking/prop/blue_staking_discount_coupon.png"),
  },
  [YULI_QUALITY_TYPE.PURPLE]: {
    text: "IV",
    prop_id: "",
    discount: 0.55,
    icon: require("@/assets/images/YuliApp/YuliStaking/prop/purple_staking_discount_coupon.png"),
  },
  [YULI_QUALITY_TYPE.GOLDEN]: {
    text: "V",
    prop_id: "",
    discount: 0.5,
    icon: require("@/assets/images/YuliApp/YuliStaking/prop/golden_staking_discount_coupon.png"),
  },
};
